// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1289) return "static/chunks/1289-0671f44478dc0730.js";
	if (chunkId === 713) return "static/chunks/713-2a89eb7bb9f118fb.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7501 ? "144d3bae" : chunkId) + "." + {"2810":"46894a85401323bd","3330":"ce7847ac7a4a7cc4","5656":"60578d85cdea5448","7501":"17e8d35a79ca3436"}[chunkId] + ".js";
};